import React from 'react';
import { FinancialPageProvider } from '@/context/FinancialPageContext';
import { FinancialScreen } from './screens';

const FinancialPageWrapper: React.FC = (): JSX.Element => (
  <FinancialPageProvider>
    <FinancialScreen />
  </FinancialPageProvider>
);

export default FinancialPageWrapper;
